import React from 'react'
import PropTypes from 'prop-types'

import TextField from '@material-ui/core/TextField'

import { Controller } from 'react-hook-form'

import { createMuiTheme } from '@material-ui/core'
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles'

// mark the required asterixes in red - see https://stackoverflow.com/questions/54936644/how-to-change-the-asterisk-color-in-required-field
const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: '#db3131',
        '&$error': {
          color: '#db3131'
        }
      }
    }
  }
})

export default function ValidatedTextField (props) {
  const {
    control, // returned from the useForm hook
    errors, // get this via formState: { errors } from the useForm hook
    name, // name should match the defaultVales field of the useForm object we are linked to via the control
    label,
    placeholder = '',
    helperText = '',
    rules = {}, // in the format of useForm register rules - disabled rule will also pass through to the TextField object
    fullWidth = true,
    type = 'text',
    variant = 'standard',
    ...otherProps
  } = props

  let disabled = false

  if (rules.disabled) {
    disabled = rules.disabled
  }

  let required = false

  if (rules.required) {
    required = !!rules.required
  }

  return (
    <MuiThemeProvider theme={formLabelsTheme}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <TextField
            {...field}
            disabled={disabled}
            required={required && !disabled}
            label={label}
            error={!!errors[name]}
            helperText={errors[name] ? errors[name].message : helperText}
            placeholder={placeholder}
            fullWidth={fullWidth}
            type={type}
            variant={variant}
            {...otherProps}
          />
        )}
      />
    </MuiThemeProvider>
  )
}

ValidatedTextField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
  control: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  rules: PropTypes.object,
  fullWidth: PropTypes.bool,
  type: PropTypes.string,
  variant: PropTypes.string
}
